// core/strategies/selective-preload.strategy.ts
import {Injectable} from '@angular/core';
import {PreloadingStrategy, Route} from '@angular/router';
import {Observable, of} from 'rxjs';

@Injectable({providedIn: 'root'})
export class SelectivePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // si no se especifica, precarga por defecto (true)
    const shouldPreload = route.data?.['preload'] !== false;
    return shouldPreload ? load() : of(null);
  }
}
